import { SimpleGrid, Skeleton, Spacer, VStack } from '@chakra-ui/react';

interface VaultCardSkeletonProps {
  seq: number;
}

const cardBackgrounds = [
  'linear-gradient(90deg, #9028FF 0%, #7042F8 46.87%);',
  'linear-gradient(90deg, #7243FA 0%, #575AF4 46.87%);',
  'linear-gradient(90deg, #575AF4 0%, #2584EB 46.87%), linear-gradient(90deg, #7243FA 0%, #575AF4 46.87%)',
];

export const VaultCardSkeleton = ({ seq }: VaultCardSkeletonProps) => {
  const bgColor = cardBackgrounds[seq % 3];

  return (
    <SimpleGrid
      w="full"
      minH={{ base: 32, lg: 36 }}
      columns={2}
      borderRadius="xl"
      overflow="hidden"
      boxShadow="0px 13.048px 0px 0px rgba(0, 0, 0, 0.30)"
    >
      <VStack background={bgColor} p={4} align="start">
        <Skeleton w={28} minH={8} />
        <Skeleton w={28} minH={6} />
        <Spacer />
        <Skeleton w={20} minH={6} />
      </VStack>
      <VStack background="#42246D" align="start">
        <VStack pt={4} px={4} align="start">
          <Skeleton w={32} minH={8} />
          <Skeleton w={28} minH={6} />
        </VStack>
        <Spacer />
        <Skeleton
          w="full"
          minH={8}
          roundedTop="none"
          roundedBottomLeft="none"
        />
      </VStack>
    </SimpleGrid>
  );
};
